// DS: i2.9
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const ArrowLongLeft: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d="M10.867 8.076c-.367-.429-1.05-1.107-1.05-1.107L5.03 12.087 9.89 16.97l1.14-1.078-3.167-3.077H18.97v-1.525H7.888l2.98-3.213z" />
    </svg>
  </IconWrap>
);
ArrowLongLeft.displayName = 'ArrowLongLeft';

export default ArrowLongLeft;
